import React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';

import style from './LanguagesTable/style.module.scss';

export function looksLikeHtml(str) {
  return typeof str === 'string' && /<[a-zA-Z][\s\S]*>/.test(str);
}

const HtmlPreviewButton = ({ value }) => {
  const popover = (
    <Popover id="html-preview-popover" className={style.htmlPreviewPopover}>
      <Popover.Content>
        {/* eslint-disable jsx-a11y/click-events-have-key-events,
            jsx-a11y/no-static-element-interactions */}
        <div
          className={style.htmlPreviewContent}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          {/* eslint-disable react/no-danger -- admin-edited HTML preview */}
          <div dangerouslySetInnerHTML={{ __html: value }} />
          {/* eslint-enable react/no-danger */}
        </div>
        {/* eslint-enable jsx-a11y/click-events-have-key-events,
            jsx-a11y/no-static-element-interactions */}
      </Popover.Content>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      placement="left"
      overlay={popover}
      rootClose
    >
      <Button
        variant="link"
        size="sm"
        className={style.previewBtn}
        style={{ color: 'inherit' }}
        onClick={(e) => e.stopPropagation()}
        title="Preview rendered HTML"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="1em" height="1em" aria-hidden="true">
          <path fill="currentColor" d="M320 128C179.2 128 90.7 256 64 320C90.7 384 179.2 512 320 512C460.8 512 549.3 384 576 320C549.3 256 460.8 128 320 128zM127.4 176.6C174.5 132.8 239.2 96 320 96C400.8 96 465.5 132.8 512.6 176.6C559.4 220.1 590.7 272 605.6 307.7C608.9 315.6 608.9 324.4 605.6 332.3C590.7 368 559.4 420 512.6 463.4C465.5 507.1 400.8 544 320 544C239.2 544 174.5 507.2 127.4 463.4C80.6 419.9 49.3 368 34.4 332.3C31.1 324.4 31.1 315.6 34.4 307.7C49.3 272 80.6 220 127.4 176.6zM320 416C373 416 416 373 416 320C416 276.7 387.3 240.1 347.9 228.1C350.6 236.9 352 246.3 352 256C352 309 309 352 256 352C246.3 352 236.9 350.6 228.1 347.9C240 387.3 276.7 416 320 416zM192.2 327.8C192 325.2 192 322.6 192 320C192 307.8 193.7 296.1 196.9 285C197.2 284.1 197.4 283.2 197.7 282.3C210.1 241.9 242 210.1 282.4 197.6C294.3 193.9 307 192 320.1 192C322.6 192 325.1 192.1 327.5 192.2L327.9 192.2C395 196.2 448.1 251.9 448.1 320C448.1 390.7 390.8 448 320.1 448C252 448 196.3 394.8 192.3 327.8zM224.3 311.7C233.6 317 244.4 320.1 255.9 320.1C291.2 320.1 319.9 291.4 319.9 256.1C319.9 244.6 316.9 233.8 311.5 224.5C265.1 228.5 228.2 265.4 224.2 311.8z" />
        </svg>
      </Button>
    </OverlayTrigger>
  );
};

export default HtmlPreviewButton;
